import SurveyService, {
  TemplateResponse,
} from '../../../services/SurveyService';
import { useQuery } from '@tanstack/react-query';
import { useActiveProjectId, useNotify, useServiceAuth } from '../../../hooks';
import { defineMessages, useIntl } from 'react-intl';

export const messages = defineMessages({
  getTemplateError: {
    id: 'surveyTemplates.getTemplateError',
    defaultMessage: 'Error occurred generating template',
  },
});

export type UseTemplatedSurveyResponseParams = {
  surveyId: string;
  templateId: string;
  responseId: string;
};

export type UseTemplatedSurveyResponseReturnValue = {
  isLoading: boolean;
  response: TemplateResponse;
};

const surveyService = new SurveyService();

export const useTemplatedSurveyResponse = ({
  surveyId,
  templateId,
  responseId,
}: UseTemplatedSurveyResponseParams): UseTemplatedSurveyResponseReturnValue => {
  const serviceAuth = useServiceAuth();
  const activeProjectId = useActiveProjectId();
  const queryKey = [
    'generate-survey-template',
    surveyId,
    templateId,
    responseId,
  ];
  const { formatMessage } = useIntl();
  const [notify] = useNotify();
  const generateTemplate = useQuery(
    queryKey,
    async () => {
      const response = await surveyService.generateTemplate(serviceAuth)(
        activeProjectId,
        surveyId,
        templateId,
        responseId,
      );
      return response.data;
    },
    {
      onError: () => {
        notify(formatMessage(messages.getTemplateError), 'error');
      },
    },
  );

  return {
    isLoading: generateTemplate.isLoading,
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    response: generateTemplate.isLoading
      ? {
          result: '',
        }
      : generateTemplate.data,
  };
};
